import { clearOverrides } from "./utils/overrides";
import { clearVisibilityCache } from "./utils/visible";

export * as fathom from "@protontech/fathom";
export * as rulesets from "./rulesets";

export * from "./constants/selectors";
export type { FeatureProvider } from "./features/v1";
export { createRulesetRegistry } from "./rulesets";
export * from "./types";
export * from "./utils/attributes";
export * from "./utils/credit-card";
export { getTypeScore } from "./utils/fathom";
export * from "./utils/field";
export * from "./utils/flags";
export * from "./utils/form";
export * from "./utils/identity";
export * from "./utils/iframe";
export * from "./utils/overrides";
export * from "./utils/prepass";
export * from "./utils/shadow-dom";
export * from "./utils/visible";

export const clearDetectionCache = () => {
  clearVisibilityCache();
  clearOverrides();
};
